module.exports = __webpack_public_path__ + "img/icon-user-list.e3dd5d2e.svg";